import authService from '@jobseeker/common-core/services/auth.service';
import {openUrl} from '@jobseeker/common-core/utils';
import {deleteCookie} from 'cookies-next';

const logout = async (reloadHome: boolean, reloadUrl = '/') => {
  // dispatch({type: 'Auth/set_user_logged_out'});
  // dispatch({type: 'User/clear_user_profile'});
  // dispatch({type: 'User/clear_profile_completeness'});
  // dispatch({type: 'AppContext/set_user_logged_out'});
  deleteCookie('filter');
  localStorage.removeItem('filter');
  localStorage.removeItem('expFilterCleared');
  if (process.env.NEXT_PUBLIC_FILTER_CAT_TAG === 'true') {
    deleteCookie('filterCat');
    localStorage.removeItem('filterCat');
  }
  try {
    await authService.logOut('logout');
  } catch (err) {
    console.log('logout err: ', err);
  } finally {
    if (typeof window !== 'undefined') {
      if (reloadHome) {
        openUrl(reloadUrl, '_self');
      } else {
        window.location.reload();
      }
    }
  }
};

export {logout};
